<template>
  <div class="content-wrapper">
    <div class="map-wrapper">
      <ServiceMap 
        @click="onSelectCentre"
        @reset="onResetCentre"
        :options="options"
        />
    </div>
    <div class="top-left-panel">
      <SearchInput />
    </div>
    <div class="top-left-panel-settings">
      <LangSwitch />
      <MarkerSwitch 
        v-model="marker"
        />
      <AreaSwitch 
        v-model="area"
        />
      <ToCenter 
        v-if="addressSelected"
        @click="onClickToCenter" 
        />
    </div>
    <div class="bottom-right-panel" v-if="ifscInfo !== null">
      <InfoPanel 
        :info="ifscInfo"
        @close="onClose"
        />
    </div>
  </div>
</template>


<script>
import { ServiceMap } from '@/components/Map'

import { Main } from '@/event-bus/main.js'

import LangSwitch from '@/components/Settings/LangSwitch/Main.vue'
import MarkerSwitch from '@/components/Settings/MarkerSwitch/Main.vue'
import AreaSwitch from '@/components/Settings/AreaSwitch/Main.vue'
import ToCenter from '@/components/Settings/ToCenter/Main.vue'

import InfoPanel from '@/components/Info/Panel/Main.vue'
import SearchInput from '@/components/Search/Input/Main.vue'

export default {
  name: "Home",
  components: {
    ServiceMap,
    LangSwitch,
    MarkerSwitch,
    AreaSwitch,
    ToCenter,
    InfoPanel,
    SearchInput,
  },
  data() {
    return {
      ifscInfo: null,
      marker: true,
      area: true,
    };
  },
  watch: {
    
  },
  computed: {
    options() {
      return {
        marker: this.marker,
        area: this.area
      }
    },
    addressSelected() {
      return typeof this.ifscInfo === 'object' && this.ifscInfo !== null && this.ifscInfo.hasOwnProperty('selected') && this.ifscInfo.selected;
    },
  },
  created() {
    
  },
  methods: {
    onSelectCentre(payload) {
      this.ifscInfo = payload;
    },
    onResetCentre() {
      if(!this.addressSelected) {
        this.ifscInfo = null;
      }
    },
    onClose() {
      this.ifscInfo = null;
      Main.$emit('reset');
    },
    onClickToCenter() {
      Main.$emit('toCenter', this.ifscInfo.info);
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  position: fixed; /* Sit on top of the page content */
  width: 100%; 
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.map-wrapper {
  height: 100%;
}
.top-left-panel {
  z-index: 999;
  position: absolute;
  left: 4rem;
  top: 1rem;
}
.top-left-panel-settings {
  z-index: 999;
  position: absolute;
  top: 5.5rem;
  left: 0.5rem;
}
.bottom-right-panel {
  z-index: 999;
  position: absolute;
  left: 50%;
  right: 1rem;
  bottom: 1rem;
}
@media screen and (max-width: 991px) {
  .bottom-right-panel {
    z-index: 999;
    position: absolute;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
  }
  .top-left-panel {
    z-index: 999;
    position: absolute;
    left: 4rem;
    right: 1rem;
    top: 1rem;
  }
}
</style>
